import React from "react";  
import { motion } from "framer-motion";  
import { RefreshCw, AlertTriangle } from "lucide-react";  
  
export const AdminLoadingState = ({ label = "Loading…" }) => (  
  <div className="flex flex-col items-center justify-center py-20">  
    <div className="relative w-12 h-12">  
      <div className="absolute inset-0 border-4 border-gold/20 rounded-full" />  
      <div className="absolute inset-0 border-4 border-gold border-t-transparent rounded-full animate-spin" />  
    </div>  
    <p className="text-gold text-sm font-semibold mt-4">{label}</p>  
  </div>  
);  
  
export const AdminEmptyState = ({ icon: Icon, title, message, action }) => (  
  <motion.div  
    initial={{ opacity: 0, y: 8 }}  
    animate={{ opacity: 1, y: 0 }}  
    className="bg-black/30 border border-gray-800 rounded-2xl p-12 text-center"  
  >  
    <div className="w-14 h-14 mx-auto mb-4 bg-gray-800/50 border border-gray-700 rounded-full flex items-center justify-center">  
      {Icon && <Icon size={22} className="text-gray-500" />}  
    </div>  
    <h3 className="text-base font-semibold text-gray-200 mb-1">{title}</h3>  
    {message && <p className="text-xs text-gray-500 max-w-sm mx-auto mb-5">{message}</p>}  
    {action}  
  </motion.div>  
);  
  
export const AdminErrorState = ({ message, onRetry }) => (  
  <motion.div  
    initial={{ opacity: 0, y: 8 }}  
    animate={{ opacity: 1, y: 0 }}  
    className="bg-red-500/5 border border-red-500/30 rounded-2xl p-8 text-center"  
  >  
    <div className="w-12 h-12 mx-auto mb-3 bg-red-500/10 border border-red-500/30 rounded-full flex items-center justify-center">  
      <AlertTriangle size={18} className="text-red-400" />  
    </div>  
    <h3 className="text-base font-semibold text-white mb-1">Something went wrong</h3>  
    <p className="text-xs text-gray-400 max-w-md mx-auto mb-4">{message}</p>  
    {onRetry && (  
      <button  
        onClick={onRetry}  
        className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 border border-gold/40 text-gold hover:bg-gold/20 text-xs font-semibold rounded-lg transition-all"  
      >  
        <RefreshCw size={14} />  
        Try again  
      </button>  
    )}  
  </motion.div>  
);  